import type { Field } from '@/api/types/crm/crm.types'

/** Первая строка «Основные поля»: контакты лида (после даты по воронке). */
export const MAIN_PROFILE_LEAD_FIELD_IDS = ['PHONE', 'EMAIL'] as const

/** Вторая строка «Основные поля»: данные родителя. */
export const MAIN_PROFILE_PARENT_FIELD_IDS = [
  'PARENTNAME',
  'PARENTPHONE',
  'PARENTEMAIL',
] as const

export type MainProfileFieldId =
  | (typeof MAIN_PROFILE_LEAD_FIELD_IDS)[number]
  | (typeof MAIN_PROFILE_PARENT_FIELD_IDS)[number]

export const pickMainProfileField = (
  fields: Field[],
  uniqueName: MainProfileFieldId,
): Field | undefined =>
  fields.find(
    (field) =>
      field.unique_name === uniqueName &&
      field.is_active &&
      field.is_default,
  )

/** VK_LINK в «Основных полях» — только если поле в каталоге выбранной воронки. */
export const pickVkLinkField = (catalogFields: Field[]): Field | undefined =>
  catalogFields.find(
    (field) => field.unique_name === 'VK_LINK' && field.is_active,
  )

export const pickTelegramAccountField = (
  catalogFields: Field[],
): Field | undefined =>
  catalogFields.find(
    (field) => field.unique_name === 'TELEGRAM_ACCOUNT' && field.is_active,
  )

export const pickMaxAccountField = (catalogFields: Field[]): Field | undefined =>
  catalogFields.find(
    (field) => field.unique_name === 'MAX_ACCOUNT' && field.is_active,
  )
